import { ReactElement, useEffect, useState } from "react";
import { ColumnsType } from "antd/es/table";
import { useNavigate } from "react-router-dom";
import { ReactSVG } from "react-svg";

import "./portfolio-types.scss";
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import CustomTable from "../../components/custom-table/custom-table";
import CustomModal from "../../components/custom-modal/custom-modal";
import DeleteModal from "../../components/delete-modal/delete-modal";
import { useDispatch, useSelector } from "react-redux";
import { CREATE_BREADCRUMB, LOADING } from "../../store/actions";
import instance from "../../store/axios";
import { AxiosResponse } from "axios";
import toast from "react-hot-toast";
import { formatNumber } from "../../utils/helper/functions";

const PortfolioTypes: React.FC = (): ReactElement => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loadingState = useSelector((state: any) => state?.loading);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [portfoliosList, setPortfoliosList] = useState([]);
  // const [selectedRecord, setSelectedRecord] = useState<any>()

  useEffect(() => {
    getPortfoliosList();

    dispatch({
      type: CREATE_BREADCRUMB,
      payload: {
        breadcrumb: [
          {
            text: "Portfolio types",
            type: "link",
            link: "/portfolio/types",
          },
        ],
      },
    });
  }, []);

  const getPortfoliosList = async (): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/portfolio-type`
      );
      setPortfoliosList(response.data.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/portfolio/types`);
    }

    dispatch({ type: LOADING, payload: false });
  };

  const columns: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      render: (_, __, index: number) => <span>{index + 1}</span>,
    },
    {
      title: "Name En",
      dataIndex: "nameEn",
      key: "nameEn",
      sorter: (a, b) => String(a?.nameEn).localeCompare(String(b?.nameEn)),
      fixed: "left",
    },
    {
      title: "Name Ar",
      dataIndex: "nameAr",
      key: "nameAr",
      sorter: (a, b) => String(a?.nameAr).localeCompare(String(b?.nameAr)),
    },
    {
      title: "Minimum amount",
      dataIndex: "minimumAmount",
      key: "minimumAmount",
      sorter: (a, b) => a?.minimumAmount - b?.minimumAmount,
      render: (text: number) => <span>{formatNumber(text)}</span>,
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
      sorter: (a, b) =>
        String(a?.currency?.currencyCode).localeCompare(
          String(b?.currency?.currencyCode)
        ),
      render: (_, record) => <span>{record.currency?.currencyCode}</span>,
    },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      render: (_, record) => (
        <div className="actions flex align-center">
          <ReactSVG
            src={"/images/edit.svg"}
            onClick={() => {
              navigate(`/portfolio/edit-portfolio/${record?.id}?edit=1`);
            }}
          />
          {/* <ReactSVG
            className="delete-icon"
            src={DeleteImage}
            onClick={() => {
              setOpenDeleteModal(true);
            }}
          /> */}
        </div>
      ),
    },
  ];

  // const onDeletePortfolio = async () => {
  //   dispatch({ type: LOADING, payload: true });

  //   try {
  //     await instance.delete(`/role/${selectedRecord?.id}`);
  //     toast.success('Portfolio type deleted successfully')
  //     getPortfoliosList()
  //     setOpenDeleteModal(false)
  //   } catch (error: any) {
  //     toast.error(error?.response?.data?.message || 'there is an error happened');
  //   }

  //   dispatch({ type: LOADING, payload: false });
  // }

  return (
    <section className="types-container flex column">
      <div className="flex align-center justify-space-between">
        <BreadcrumbComponent />
        {/* <button
          className="flex align-center justify-center"
          onClick={() => navigate("/portfolio/add-portfolio")}
        >
          <img src={AddImage} alt="add-country kamco" />
          <span>Add portfolio</span>
        </button> */}
      </div>

      <div className="types-table">
        <div className="title flex align-center justify-space-between">
          <p>{!loadingState ? portfoliosList?.length : ""} portfolio types</p>
        </div>
        {portfoliosList?.length ? (
          <CustomTable
            columns={columns}
            data={portfoliosList}
            showPagination={false}
          />
        ) : !loadingState ? (
          <div className="flex flex-col gap-3 w-full items-center justify-center mt-9">
            <img
              className="w-[40px] h-[40px]"
              src="/images/no-items.svg"
              alt="no data kamco"
            />
            <p className="text-lg text-gray-500 font-medium">
              There are no items in this list
            </p>
          </div>
        ) : (
          ""
        )}
      </div>

      <CustomModal
        isVisible={openDeleteModal}
        centered
        width={450}
        onClose={() => {
          setOpenDeleteModal(false);
        }}
        className="delete-modal"
      >
        <DeleteModal
          onCancel={() => setOpenDeleteModal(false)}
          // onConfirm={onDeletePortfolio}
          text="Delete portfolio type!"
          subText={`Are you sure you want to delete this portfolio type?`}
        />
      </CustomModal>
    </section>
  );
};

export default PortfolioTypes;
